// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-84058c92] .el-dialog__body{overflow:auto!important}[data-v-84058c92] .el-input-number .el-input__inner{text-align:left!important}.el-tabs[data-v-84058c92]{padding:10px 5px}.el-tab-pane[data-v-84058c92]{padding:10px 0}", ""]);
// Exports
module.exports = exports;
